import { SVGProps } from 'react';
const SvgIconFacebookCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 100 100" {...props}>
    <g id="icon_facebook" transform="translate(-167 -3583)">
      <g id="Group_4551" data-name="Group 4551" transform="translate(167 3583)">
        <rect
          id="Rectangle_806"
          data-name="Rectangle 806"
          width={100}
          height={100}
          transform="translate(0 0)"
          fill="#fff"
          opacity={0}
        />
        <g id="icon_facebook-2" data-name="icon_facebook" transform="translate(-482.09 -2510.016)">
          <path
            id="Path_23"
            data-name="Path 23"
            d="M530.661,2579.356h5.521V2606.2"
            transform="translate(-12.571 -19.34)"
            fill="none"
            stroke="#0084f5"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
          />
          <path
            id="Path_24"
            data-name="Path 24"
            d="M529.64,2557.136h6.209v-8.054s.388-9.785,10.871-9.785h9.4v9.785h-4.9s-3.065.332-3.065,2.416v5.389h8.581l-1.471,9.413h-7.355v26.842h-7.478"
            transform="translate(-12.238 -6.284)"
            fill="none"
            stroke="#0084f5"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
          />
          <path
            id="Path_25"
            data-name="Path 25"
            d="M532.09,2600.016a39.958,39.958,0,1,1,10.717-1.452"
            transform="translate(0)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
          />
        </g>
      </g>
    </g>
  </svg>
);
export default SvgIconFacebookCircle;
